import { RigidBody } from '@react-three/rapier';
import { Text } from '@react-three/drei';

import { FlagModel } from '@fiber/Flag';

export function BlockEnd({ position = [0, 0, 0] }) {
    return (
        <group position={position}>
            <Text
                scale={1}
                position={[0, 2.25, 2]}
                font='./bebas-neue-v9-latin-regular.woff'
            >
                FINISH
                <meshBasicMaterial toneMapped={false} />
            </Text>

            {/* <RigidBody type="fixed" colliders="hull" restitution={0.2} friction={0} position={[0, 0.25, 0]}>
                <FlagModel />
            </RigidBody> */}
        </group>
    )
}